<script setup>
import loginStatusComponent from "@/components/top/loginStatusComponent.vue";
import LogoComponent from "@/components/top/logoComponent.vue";
import MenuComponent from "@/components/top/menuComponent.vue";
import TopTitleComponent from "@/components/top/IndexTopTitleComponent.vue";
import {onBeforeMount, onBeforeUnmount, onMounted, ref, toRef, watch} from "vue";
import LanguageComponent from "@/components/common/languageComponent.vue";
import {useAgeStore, useComStore, useFolderStore, useLanguageStore, useLoginStore} from "@/pinia";
import axios from "@/axios";
import {useRoute, useRouter} from "vue-router";

const loginStore = useLoginStore()
const folderStore = useFolderStore();
const useComCode = useComStore();
const ageStore = useAgeStore();
const languageStore = useLanguageStore();

const title = ref("");
const loginStatus = toRef(loginStore.getLoginStatus);
const router = useRouter();
const route = useRoute();
const selectMenu = ref("");
const menuModalStatus = ref(false);

const set_menuModalStatus = () => {
  menuModalStatus.value = !menuModalStatus.value;
}
const closeMenu = () => {
  menuModalStatus.value = false;
}

// 라우트 변경 시 메뉴 닫기
watch(() => route.path, () => {
  closeMenu();
})

const set_title = (nTitle) =>{
  title.value = nTitle;
}
const fn_logout =()=>{
  loginStore.reset();
  axios.post("/api/logout")
}
const set_selectMenu = (s)=>{
  selectMenu.value = s;
  set_menuModalStatus();
}
const go_main = ()=>{
  set_title("");
  if(!loginStatus.value){
    router.push("/login")
  }else{
    router.push("/")
  }
}

onBeforeMount(()=>{
  if(!loginStatus.value){
    router.push("/login")
  } else {
    if(!useComCode.commonCode || useComCode.commonCode.length === 0) useComCode.setCommonCode();
    if(!useComCode.groupCodes || useComCode.groupCodes.length === 0) useComCode.setGroupCodes();
    if(!useComCode.useCommonCodes || useComCode.useCommonCodes.length === 0) useComCode.setUseCommonCodes();
    if(!folderStore.folder) folderStore.getFolder();
    if(!ageStore.ages) ageStore.setAges();
  }
})
</script>

<template>
  <div class="topMenuArea">
    <div class="logoArea">
      <div class="w-33" @click="go_main">
        <logo-component></logo-component>
      </div>
      <div>{{ languageStore.get('internetBroadcastSystem') }}</div>
    </div>
    <top-title-component
        :title="title">
    </top-title-component>
    <language-component />
    <login-status-component
        @set_menuModalStatus = "set_menuModalStatus"
        :login-status="loginStatus"
        @fn_logout="fn_logout">
    </login-status-component>
    <menu-component
        :menu-modal-status="menuModalStatus"
        @set_select-menu ="set_selectMenu"
        :selectMenu="selectMenu"
    ></menu-component>
  </div>
  <div v-if="menuModalStatus" class="menuOverlay" @click="closeMenu"></div>
  <div class="mainArea">
    <router-view @set_title="set_title" ></router-view>
  </div>
  <div class="footerArea">

  </div>
</template>

<style>
@import "@/assets/reset.css"; 

.logoArea div{
  margin-left: 10px;
  font-weight: bold;
}

.topMenuArea{
  height: 8vh;
  display: flex;
  margin: 0 10px 0 10px;
}
.mainArea{
  border-top: 1px solid #AFAFAF;
  width: 100%;
  height: 90vh;
  background: #EEF1F5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.logoArea{
  display: flex;
  width: 16vw;
  height: 100%;
  align-items: center;
  cursor:pointer;
}
.menuOverlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}

</style>
